var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08964 25.6693H11.3005L18.668 16.3359H23.3346C23.9535 16.3359 24.547 16.0901 24.9846 15.6525C25.4221 15.2149 25.668 14.6214 25.668 14.0026C25.668 13.3838 25.4221 12.7903 24.9846 12.3527C24.547 11.9151 23.9535 11.6693 23.3346 11.6693H18.5455L11.178 2.33594H9.0908L12.3691 11.6693L7.0013 11.6693L4.66797 8.16927L2.33464 8.16927L4.66797 14.0026L2.33464 19.8359H4.66797L7.0013 16.3359H12.4671L9.08964 25.6693Z",
    fill: "#1B2646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.4d2d12d721ac2ca1fa324ad0550a779a.svg";
export { ForwardRef as ReactComponent };